import * as blkTools from './blocklyTools'
import { getJsInterface } from './jsInterface'

const tools = {
  ...blkTools,
  getJsInterface,
};

export default tools
